"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPosition = void 0;
/**
 * 获取点击元素的位置，用于浮动弹窗
 * @param e
 * @param offset
 * @returns
 */
const getPosition = (e, placement = 'right', widthOffset = 0) => {
    const offset = 2;
    const el = e.target;
    if (!el) {
        return {
            left: e.clientX + offset,
            top: e.clientY + offset,
        };
    }
    const rect = el.getBoundingClientRect();
    if (placement === 'left') {
        return {
            left: rect.left - widthOffset - offset,
            top: rect.bottom + offset,
        };
    }
    return {
        left: rect.left + rect.width + offset,
        top: rect.bottom + offset,
    };
};
exports.getPosition = getPosition;
//# sourceMappingURL=position.js.map